"use client";

import * as React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { DialogClose } from "@radix-ui/react-dialog";

interface ApproveModalProps {
  id: string;
  onConfirm: (id: string) => void;
  onClose: () => void;
}

export function ApprovalModal({ id, onConfirm }: ApproveModalProps) {
  const [open, setOpen] = React.useState(false);

  const handleConfirm = () => {
    onConfirm(id);
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button
          type="button"
          className="bg-[#FFCC32] text-black rounded-md font-semibold text-sm p-2 px-4 flex items-center gap-2 hover:[#FFCC32]/80"
        >
          Aprovar Query
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[595px] bg-white">
        <DialogHeader>
          <DialogTitle>Tem Certeza?</DialogTitle>
          <DialogDescription>
            Ao confirmar, a query selecionada será executada no banco de dados.
            Qualquer problema resultante será de sua inteira responsabilidade.
            Todas as alterações realizadas serão registradas em logs para
            futuras análises e auditorias.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose>
            <Button className="bg-transparent border border-black/20 text-black rounded-md font-semibold text-sm p-2 px-4 flex items-center gap-2 hover:bg-black/10">
              Cancelar
            </Button>
          </DialogClose>
          <Button
            type="button"
            onClick={handleConfirm}
            className="bg-[#FFCC32] text-black rounded-md font-semibold text-sm p-2 px-4 flex items-center gap-2 hover:[#FFCC32]/80"
          >
            Aprovar Query
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
